import angular from 'angular';

export class HeaderComponent {
  constructor(Auth, $scope, Application, $stateParams) {
    'ngInject';
    var vm = this
    vm.previous = function() {
      Application.previous($stateParams.id);
    }
  }
}

export default angular.module('directives.header', [])
  .component('header', {
    template: require('./header.html'),
    controller: HeaderComponent,
    controllerAs: 'vm'
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/header/header.component.js